import { RightOutlined } from "@ant-design/icons";
import {

    Row,
    Col,

    Button,

    Form,
    Input,
    
    Select,
   
    Radio,
    
    Space,
    Spin,
   

} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';

import accountService from "../../../api/account.service";
import groupService from "../../../api/group.service";
import { addAccount } from "../../../store/accountSlice";




import {  EDIT_MODE, SUCCESS_STATUS } from "../../../utility/Constants";
import commonUtility from "../../../utility/Utils";
import CustomMessage from "../../common/CustomMessage";
import TextArea from "antd/lib/input/TextArea";
const { Option } = Select;



const AccountEntry = ({ data , onDrawerClose }) => {

    const dispatch = useDispatch();

  // console.log(data)
  const [isLoaderEnable, setIsLoaderEnable] = useState(false);
  const [isFormResponse, setIsFormResponse] = useState(false);
  const [formResponseMessage, setFormResponseMessage] = useState("");
  const [formResponseStatus, setFormResponseStatus] = useState("");

  const [groupList, setGroupList] = useState([]);
  const [stateList, setStateList] = useState([]);

  const [isSundryDebtorOrCreditor, setIsSundryDebtorOrCreditor] = useState(false);
  
  const [formDefaultValues, setFormDefaultValues] = useState({
    id: data.id,
    account_name: data.account_name,   
    opening_balance: data.opening_balance,   
    group_master_id: data.group_master_id,
    group_description: data.group_description,
    is_special: data.is_special,
    is_closingstk: data.is_closingstk,
    mode: data.mode,

    hsn_code:data.hsn_code,
    gstin:data.gstin,
    state:data.state,
    address:data.address,

  });

  const [mode, setMode] = useState(data.mode);


  const [form] = Form.useForm();

  const onAccountSave = async (values) => {
      
        setIsLoaderEnable(true);
      const data = { formdata: values };

        const response = accountService.accountSave(data).then((resdata) => {
          setIsFormResponse(true);
          setFormResponseStatus(resdata.response_status);
          setFormResponseMessage(resdata.response_msg);
          setIsLoaderEnable(false);
      });

      const x = {
        coach_id:commonUtility.randomID(),
        account_name:values.account_name
    }
    dispatch(addAccount(x))

        
  };


  const hideResponseMessage = () => {
      setIsFormResponse(false);
      
      if(form.getFieldValue('mode') == "ADD") {
        form.resetFields()
        form.setFieldsValue({
            id: formDefaultValues.id,
            mode: formDefaultValues.mode,
            is_special: 'N',
            is_closingstk: 'N'
        })
    }
  }


  const onGroupChange = (v,e) => {
        setIsSundryDebtorOrCreditor(false);

        

        form.setFieldsValue({
            state:"",
            gstin:"",
            address:"",
        });
        

        if(e.children == "Sundry Creditors" || e.children == "Sundry Debtors"){
            setIsSundryDebtorOrCreditor(true);
        }
    }

  useEffect(() => {

     
      mode == EDIT_MODE ?

          form.setFieldsValue({
            id: formDefaultValues.id,
            account_name: formDefaultValues.account_name,
            opening_balance: formDefaultValues.opening_balance,
            group_master_id: formDefaultValues.group_master_id,
            is_special: formDefaultValues.is_special,
            is_closingstk: formDefaultValues.is_closingstk,
            mode: formDefaultValues.mode,

            hsn_code:formDefaultValues.hsn_code,
            gstin:formDefaultValues.gstin,
            state:formDefaultValues.state,
            address:formDefaultValues.address,

          })
          :
          form.setFieldsValue({
            id: 0,
            account_name: '',
            opening_balance:0,
            group_master_id: '',
            is_special: 'N',
            is_closingstk: 'N',
            mode: data.mode,
            hsn_code:'',
            gstin:'',
            state:'',
            address:'',
        });


      form.setFieldsValue(formDefaultValues)

  }, [form]);

  // useEffect for sundry debtor
  useEffect(()=> {
    setIsSundryDebtorOrCreditor(false);
    if(formDefaultValues.group_description == "Sundry Creditors" || formDefaultValues.group_description == "Sundry Debtors"){
        setIsSundryDebtorOrCreditor(true);
    }
  },[form]);



  useEffect(() => {
    groupService.groupList().then((res) => {
          if (res.data.response_status === SUCCESS_STATUS) {
              setGroupList(res.data.response_data);
          }

      });
  }, []);

  useEffect(() => {
    accountService.stateList().then((res) => {
          if (res.response_status === SUCCESS_STATUS) {
                setStateList(res.response_data);
          }

      });
  }, []);




  return (
      <div>
          <div className="form-input-style">

              <Row className="" style={{ background: "transparent" }}>
                  <Col className="" xs={24} xl={24}>
                      <Form
                          form={form}
                          layout="vertical"
                          onFinish={onAccountSave}
                          autoComplete="off"
                       initialValues={formDefaultValues}
                      >

                          {/* <Row gutter={20}>
                          <Col className="gutter-row" xs={24} xl={24}>
                              <h5>Note: * fields are required</h5>
                          </Col>
                      </Row> */}
                          <Row gutter={20}>
                          <Col className="gutter-row" xs={24} xl={24}>

                            <Form.Item name="account_name" label="Ledger" rules={[
                                {
                                    required: true,
                                    message: 'Ledger is required',
                                },
                            ]}>
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item name="id" label="id" hidden={true}>
                                <Input type="text" />
                            </Form.Item>
                            <Form.Item name="mode" label="mode" hidden={true}>
                                <Input type="text" />
                            </Form.Item>
                            </Col>
                              
                              <Col xs={24} xl={24}>
                                  <Form.Item name="group_master_id" label="Group" rules={[
                                      {
                                          required: true,
                                          message: 'Group is required',
                                      },
                                  ]}>
                                      <Select className="text-left" 
                                       showSearch
                                       placeholder="Search to Select"
                                       optionFilterProp="children"
                                       filterOption={(input, option) =>
                                           //option.children.includes(input)
                                           option.children.toLowerCase().includes(input.toLowerCase())
                                       }
                                       filterSort={(optionA, optionB) =>
                                           optionA.children
                                               .toLowerCase()
                                               .localeCompare(optionB.children.toLowerCase())
                                       }
                                       placement="bottomLeft"
                                       allowClear={true}
                                       onSelect={(value, event) =>
                                        onGroupChange(value, event)
                                       }
                                      >
                                      
                                          {
                                              groupList.length > 0 ?
                                              groupList.map(group_data => (
                                                      <Option key={group_data.group_id} value={group_data.group_id}>{group_data.group_description}</Option>

                                                  ))
                                                  : ''
                                          }
                                      </Select>
                                  </Form.Item>
                              </Col>

                              


                              <Col className="gutter-row" xs={24} xl={12}>
                                <Form.Item name="hsn_code" label="HSN" >
                                      <Input placeholder="" />
                                </Form.Item>
                              </Col>

                              <Col className="gutter-row" xs={24} xl={12} hidden={!isSundryDebtorOrCreditor} >
                                <Form.Item name="gstin" label="GSTIN" >
                                      <Input placeholder="" />
                                </Form.Item>
                              </Col>

                             

                              <Col xs={24} xl={12} hidden={!isSundryDebtorOrCreditor} >
                                  <Form.Item name="state" label="State" rules={[
                                      {
                                          required: false,
                                          message: '',
                                      },
                                  ]}>
                                      <Select className="text-left" 
                                       showSearch
                                       placeholder="Search to Select"
                                       optionFilterProp="children"
                                    //    filterOption={(input, option) =>
                                    //        //option.children.includes(input)
                                    //        option.children.toLowerCase().includes(input.toLowerCase())
                                    //    }
                                    //    filterSort={(optionA, optionB) =>
                                    //        optionA.children
                                    //            .toLowerCase()
                                    //            .localeCompare(optionB.children.toLowerCase())
                                    //    }
                                       placement="bottomLeft"
                                       allowClear={true}
                                      >
                                      
                                        {
                                              stateList.length > 0 ?
                                              stateList.map(state_list => (
                                                      <Option key={state_list.id} value={state_list.id}>{state_list.state_name}</Option>

                                                  ))
                                                  : ''
                                          }
                                      </Select>
                                  </Form.Item>
                              </Col>

                              <Col className="gutter-row" xs={24} xl={12} hidden={!isSundryDebtorOrCreditor} >
                                <Form.Item name="address" label="Address" >
                                    <TextArea placeholder="" rows={2} />
                                </Form.Item>
                              </Col>

                             

                              <Col className="gutter-row" xs={24} xl={24} hidden={true}>

                                  <Form.Item name="opening_balance" label="Opening Balance" >
                                      <Input placeholder="" />
                                  </Form.Item>
                                 
                              </Col>

                              

                              <Col xs={24} xl={12}>
                                  <Form.Item name="is_special" label="Special" hidden={true}>
                                      <Radio.Group
                                          
                                          style={{ width: "100%" }}
                                          optionType="button"
                                          buttonStyle="solid"
                                      >
                                          <Radio.Button value="Y">Yes</Radio.Button>
                                          <Radio.Button value="N">No</Radio.Button>
                                      </Radio.Group>
                                  </Form.Item>
                              </Col>

                              <Col xs={24} xl={12}>
                                  <Form.Item name="is_closingstk" label="Closing Stock" hidden={true}>
                                      <Radio.Group
                                         
                                          style={{ width: "100%" }}
                                          optionType="button"
                                          buttonStyle="solid"
                                      >
                                          <Radio.Button value="Y">Yes</Radio.Button>
                                          <Radio.Button value="N">No</Radio.Button>
                                      </Radio.Group>
                                  </Form.Item>
                              </Col>
                            

                              <Col xs={24} xl={24} align="right">
                                  <Form.Item name="" label=" ">
                                      <Space>

                                         

                                          {
                                                isLoaderEnable ? <Spin /> : <>
                                                    <Button className="custom-button-green" htmlType="submit">
                                                        Save <RightOutlined />
                                                    </Button>
                                                </>
                                            }
                                      </Space>
                                  </Form.Item>
                              </Col>


                          </Row>
                      </Form>



                  </Col>
              </Row>
               {
                  isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} /> : ''
               }                       
              



          </div>
      </div>
  );
}

export default AccountEntry